const DRAWER_TABS = {
  INPUT: '0',
  OUTPUT: '1',
  REQUEST: '2',
  RESPONSE: '3',
};

export default DRAWER_TABS;
